import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import Error404 from '../../components/Error/Error404'
import { useParams } from 'react-router-dom'
import { Button, Col, Container, Row } from 'react-bootstrap';
// import { SiFacebook, SiTwitter } from 'react-icons/si'
import { LinkContainer } from 'react-router-bootstrap';

import './blogDetails.css';

const BlogDraftDetails = pros => {

  const { draftId } = useParams()

  const [selectedDraft, setSelectedDraft] = useState()

  const { loading, blogDrafts } = useSelector(state => state.all)

  useEffect(() => {
    // let singleBlog = blog.find(item => item._id === draftId)
    // if (singleBlog) {
    setSelectedDraft(blogDrafts && blogDrafts.find(item => item.draftId === draftId))
    // }
  }, [draftId, blogDrafts])

  useEffect(() => {
    if (selectedDraft && selectedDraft.body) {
      document.getElementById('blog-body').innerHTML = selectedDraft.body
    }
  }, [selectedDraft, blogDrafts])

  const currentUrl = window.location.href;

  const loadFbApi = () => {

    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '420319592989109',
        xfbml: true,
        version: 'v12.0'
      });
      window.FB.AppEvents.logPageView();
    };

    // Load the SDK asynchronously
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  useEffect(() => {
    loadFbApi();
  });

  return (
    loading ? <Loading /> : selectedDraft ? <>
      <Container fluid>
        <Row>
          <Col xs={12} className="px-0">
            {selectedDraft && <img className="blog-details-cover img-fluid" src={`${bucket_url}${selectedDraft.coverPhoto}`} alt="Cover" />}
          </Col>
        </Row>

        <section className="article-section pt-4 pb-5">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="article-header w-100 py-3">
                  <h1 className="article-title">{selectedDraft && selectedDraft.title}</h1>
                  <div className="article-meta">
                    <span className="text-secondary font-italic mr-1">Published at: <span>14 Oct 2021</span></span>
                  </div>
                </div>
              </Col>
              <Col xs={12}>
                <div id='blog-body' className="article-body w-100 text-secondary">

                </div>
              </Col>
              <Col xs={12} className="mt-3">
                <div class="fb-like" data-href={currentUrl} data-width="" data-layout="standard" data-action="like" data-size="small" data-share="true"></div>
              </Col>
              <Col xs={12}>
                <div className="tags-section w-100 pt-5">
                  <h5 className="text-dark mb-3">Tag List:</h5>
                  <ul className="tags-wrap d-inline-flex list-unstyled w-100 flex-wrap">
                    {/* <li className="px-1 mb-1"><LinkContainer to="#"><Button className="custom-btn-dark" variant="primary">Tag 1</Button></LinkContainer></li> */}
                    {selectedDraft && selectedDraft.tags.map(item => (
                      <li className="px-1 mb-1"><LinkContainer to="#"><Button className="custom-btn-dark" variant="primary">{item}</Button></LinkContainer></li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col xs={12}>
                <div className="fb-comments" data-href={currentUrl} data-width="" data-numposts="5"></div>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>
    </> : <Error404 />
  )
}

export default BlogDraftDetails;